import { Skeleton } from '@mui/material';

// Placeholder shown while the CMS page content is loading - roughly the shape of a typical page:
// a heading followed by a few paragraphs.
const paragraphLineWidths = ['100%', '96%', '90%', '60%'];
const paragraphCount = 3;

export default function CmsContainerSkeleton() {
    return (
        <div data-testid="cms-container-skeleton" aria-busy="true">
            <Skeleton variant="text" width="40%" height={48} />
            {[...Array(paragraphCount)].map((_, paragraphIndex) => (
                <div key={paragraphIndex} style={{ marginTop: '1.5rem' }}>
                    {paragraphLineWidths.map((width, lineIndex) => (
                        <Skeleton key={lineIndex} variant="text" width={width} />
                    ))}
                </div>
            ))}
        </div>
    );
}
